module.exports = __webpack_public_path__ + "img/q8.9a0bff61.jpeg";